import { UpdateParticipantStepStatusPayload } from '../ParticipantStepsDataProvider/ParticipantStepsContext';
import { useControllerData } from '../main/controllerContext';
import { ParticipantSection, ParticipantStep } from '../../types/v3Types';
import { ExtendedStepMap } from './requestParticipantStep';
import { getDetails } from '../../selectors/step';

export interface IParticipantSectionsContext {
  selectedSection?: ParticipantSection;
  extendedStepMap: ExtendedStepMap;
  isListParticipantSectionsRequestInProgress: boolean;
  listParticipantSections: ParticipantSection[];
  participantSteps: { steps: ParticipantStep[] } | null;
  updateParticipantSections(): void;
  selectedStep?: ParticipantStep;
  updateParticipantSteps(
    currentDate?: Date,
    includeAll?: boolean,
  ): Promise<void>;
  isParticipantStepsLoading: boolean;
  updateParticipantStepStatus(
    payload: UpdateParticipantStepStatusPayload,
  ): void;
  requestParticipantSectionStatus:
    | 'INITIAL'
    | 'IN_PROGRESS'
    | 'SUCCESS'
    | 'FAILED';
  requestParticipantSection(
    sectionId: string,
    sections: ParticipantSection[],
  ): Promise<void>;
  requestParticipantStep(stepId: string): Promise<void>;
}

export const participantSectionsContextDefaultValue: IParticipantSectionsContext =
  {
    isParticipantStepsLoading: false,
    updateParticipantStepStatus(): void {},
    extendedStepMap: {},
    updateParticipantSteps(): Promise<void> {
      return Promise.resolve(undefined);
    },
    selectedSection: undefined,
    isListParticipantSectionsRequestInProgress: false,
    listParticipantSections: null,
    participantSteps: null,
    updateParticipantSections: null,
    requestParticipantSectionStatus: 'INITIAL',
    requestParticipantSection: null,
    requestParticipantStep: null,
  };

export const useSections = () => {
  const props = useControllerData();
  return {
    selectedSection: props.selectedSection,
    participantSteps: props.participantSteps,
    isListParticipantSectionsRequestInProgress:
      props.isListParticipantSectionsRequestInProgress,
    listParticipantSections: props.listParticipantSections,
    updateParticipantSections: props.updateParticipantSections,
    selectedStep: props.selectedStep,
    updateParticipantSteps: props.updateParticipantSteps,
    isParticipantStepsLoading: props.isParticipantStepsLoading,
    updateParticipantStepStatus: props.updateParticipantStepStatus,
    requestParticipantSectionStatus: props.requestParticipantSectionStatus,
    requestParticipantSection: props.requestParticipantSection,
    requestParticipantStep: props.requestParticipantStep,
    extendedStepMap: props.extendedStepMap,
    getStepDescriptionById(stepId: string): string {
      return getDetails(props?.extendedStepMap?.[stepId]);
    },
    stepDescriptionLoaded(stepId: string): boolean {
      return stepId in props.extendedStepMap;
    },
  };
};
